module.exports = "<my-tabs (clickTabFirst)=\"openNew($event)\">\n  <my-tab [tabTitle]=\"'Thêm'\">\n  </my-tab>\n</my-tabs>\n<ng-template  let-data=\"data\" let-tabIndex=\"tabIndex\" #detailTemplate>\n  <detail [data]=\"data\" [tabIndex]=\"tabIndex\" id=\"tab-{{tabIndex}}\"></detail>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/mytab/mytab.component.html
// module id = ./src/app/layout/mytab/mytab.component.html
// module chunks = main